import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { RichText as PrismicRichText } from "prismic-dom";
import { Box, Flex } from "rebass";

import { Article, GradientCard, H3, H4, PageSection } from "components";

let linkResolver = function (doc) {
  return "/" + doc.type;
};

const Overlay = styled(Box)`
  position: absolute;
  background-color: ${(props) => props.theme.colors.violet};
  opacity: 0.85;
  top: -32px;
  left: -24px;
  width: calc(100% + 48px);
  height: calc(100% + 64px);
`;

import theme from "../../theme";
import invertTheme from "../../invertTheme";

export const CalloutCards = (props) => {
  return (
    <PageSection>
      <Flex width={1 / 1} flexWrap="wrap" ml={-4} mt={-4}>
        {props.items &&
          props.items.map((card, index) => (
            <Box
              position="relative"
              width={[1 / 1, 1 / 2, 1 / 2]}
              pl={4}
              pt={4}
              key={`card-${index}`}
              height="100%"
            >
              <ThemeProvider theme={index % 2 === 0 ? invertTheme : theme}>
                <GradientCard image={card.image && card.image.half.url}>
                  {index % 2 === 0 && <Overlay />}
                  <Flex
                    flexDirection="column"
                    justifyContent="space-between"
                    height="100%"
                    style={{ position: "relative" }}
                    px={[2, 4, 5]}
                  >
                    <Flex
                      flexDirection="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <H4 children="BIC | Taking Action" />
                      {card.flag && <H4>{card.flag}</H4>}
                    </Flex>
                    <H3
                      children={
                        card.title && card.title[0] && card.title[0].text
                      }
                      py={[4, 5]}
                    />
                    {card.description && card.description[0] && (
                      <Article
                        dangerouslySetInnerHTML={{
                          __html: PrismicRichText.asHtml(
                            card.description,
                            linkResolver
                          ),
                        }}
                      />
                    )}
                  </Flex>
                </GradientCard>
              </ThemeProvider>
            </Box>
          ))}
      </Flex>
    </PageSection>
  );
};



// WEBPACK FOOTER //
// ./src/slices/CalloutCards/CalloutCards.js